var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
    _vm.loaded
      ? _c(
          "div",
          { key: "player", staticClass: "t-vplayer t-vplayer--embed" },
          [
            _c(
              "div",
              { staticClass: "t-vplayer__main" },
              [
                _vm.video.accessUrl
                  ? _c("video-player", {
                      attrs: {
                        video: _vm.video,
                        poster: _vm.video.url,
                        embed: true,
                        autoplay: _vm.autoplay,
                        "show-signup-at-end": _vm.isFreemiumUser,
                      },
                      on: { video_loaded: _vm.startTracker },
                    })
                  : _vm.video.deleted || _vm.videoInAccessible
                  ? _c("video-not-available", {
                      key: "video-not-found",
                      attrs: { code: _vm.errorCode },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        )
      : _c(
          "div",
          { key: "loader", staticClass: "t-vplayer__loader" },
          [_c("loader", { attrs: { spinner: !_vm.isFreemiumUser } })],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }